import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { CustomDatePicker } from '../../datepicker'
import { Input, SearchSelect } from '../../input'

import { FONTS } from '../../../constants'
import {
  _title,
  _title_th,
  _marital_status,
  _gender,
} from '../types'

export const PersonalInfo = props => {
  const {
    emp,
    invalid,
    handleInput,
  } = props

  const title = _title.find(t => t.value === emp.title)
  const title_th = _title_th.find(t => t.value === emp.title_th)
  const gender = _gender.find(g => g.value === emp.gender)
  const marital_status = _marital_status.find(m => m.value === emp.marital_status)

  return (
    <Root>
      <Container>
        <Form>
          <FormWrapper>
            <FormGroup>
              <LabelCol>
                <Label required>Employee ID</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emp_code'
                  placeholder='Enter Employee ID'
                  value={ emp.emp_code || '' }
                  invalid={ invalid['emp_code'] }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'emp_code')
                  } }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>ID Card</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='id_card'
                  placeholder='Enter ID Card'
                  value={ emp.id_card || '' }
                  invalid={ invalid['id_card'] }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'id_card')
                  } }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Title (EN)</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='title'
                  placeholder='Enter Title (EN)'
                  value={ title }
                  options={ _title }
                  onChange={ e => handleInput(e, 'title') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Title (TH)</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='title_th'
                  placeholder='Enter Title (TH)'
                  value={ title_th }
                  options={ _title_th }
                  onChange={ e => handleInput(e, 'title_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>First Name (EN)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='first_name'
                  placeholder='Enter First Name (EN)'
                  invalid={ invalid['first_name'] }
                  value={ emp.first_name || '' }
                  onChange={ e => handleInput(e.target.value, 'first_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Last Name (EN)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='last_name'
                  placeholder='Enter Last Name (EN)'
                  invalid={ invalid['last_name'] }
                  value={ emp.last_name || '' }
                  onChange={ e => handleInput(e.target.value, 'last_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>First Name (TH)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='first_name_th'
                  placeholder='Enter First Name (TH)'
                  invalid={ invalid['first_name_th'] }
                  value={ emp.first_name_th || '' }
                  onChange={ e => handleInput(e.target.value, 'first_name_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Last Name (TH)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='last_name_th'
                  placeholder='Enter Last Name (TH)'
                  invalid={ invalid['last_name_th'] }
                  value={ emp.last_name_th || '' }
                  onChange={ e => handleInput(e.target.value, 'last_name_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Nickname (EN)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='nick_name'
                  placeholder='Enter Nickname (EN)'
                  invalid={ invalid['nick_name'] }
                  value={ emp.nick_name || '' }
                  onChange={ e => handleInput(e.target.value, 'nick_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Nickname (TH)</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='nick_name_th'
                  placeholder='Enter Nickname (TH)'
                  invalid={ invalid['nick_name_th'] }
                  value={ emp.nick_name_th || '' }
                  onChange={ e => handleInput(e.target.value, 'nick_name_th') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Birth Date</Label>
              </LabelCol>
              <InputCol>
                <CustomDatePicker
                  showYearDropdown
                  showMonthDropdown
                  autoComplete='off'
                  name='birth_date'
                  dateFormat='DD/MM/YYYY'
                  selected={ emp.birth_date ? moment(emp.birth_date) : null }
                  onChange={ e => handleInput(e, 'birth_date') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label required>Gender</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='gender'
                  placeholder='Select Gender'
                  value={ gender }
                  invalid={ invalid['gender'] }
                  options={ _gender }
                  onChange={ e => handleInput(e, 'gender') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Nationality</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='nationality'
                  placeholder='Enter Nationality'
                  value={ emp.nationality || '' }
                  onChange={ e => handleInput(e.target.value, 'nationality') }
                />
              </InputCol>
            </FormGroup>
          </FormWrapper>
          <FormWrapper>
            <FormGroup>
              <LabelCol>
                <Label>Phone Number</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='phone'
                  placeholder='Enter Phone Number'
                  value={ emp.phone || '' }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'phone')
                  } }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Personal Email</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='personal_email'
                  placeholder='Enter Personal Email'
                  value={ emp.personal_email || '' }
                  onChange={ e => handleInput(e.target.value, 'personal_email') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Address</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='address'
                  placeholder='Enter Address'
                  value={ emp.address || '' }
                  onChange={ e => handleInput(e.target.value, 'address') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Marital Status</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='marital_status'
                  placeholder='Select Marital Status'
                  value={ marital_status }
                  options={ _marital_status }
                  onChange={ e => handleInput(e, 'marital_status') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Children</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='number_of_children'
                  placeholder='Enter Children'
                  type='number'
                  value={ emp.number_of_children || '' }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'number_of_children')
                  } }
                />
              </InputCol>
            </FormGroup>
            <TextSection>Emergency Contact</TextSection>
            <FormGroup>
              <LabelCol>
                <Label>Name</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emergency_contact_name'
                  placeholder='Enter Name'
                  value={ emp.emergency_contact_name || '' }
                  onChange={ e => handleInput(e.target.value, 'emergency_contact_name') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Relationship</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emergency_relationship'
                  placeholder='Enter Relationship'
                  value={ emp.emergency_relationship || '' }
                  onChange={ e => handleInput(e.target.value, 'emergency_relationship') }
                />
              </InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Phone Number</Label>
              </LabelCol>
              <InputCol>
                <Input
                  name='emergency_phone_number'
                  placeholder='Enter Phone Number'
                  value={ emp.emergency_phone_number || '' }
                  onChange={ e => {
                    const value = e.target.value
                    if (!new RegExp('^[0-9]*$').test(value)) {
                      e.target.value = value.substring(0, value.length - 1)
                    }
                    handleInput(e.target.value, 'emergency_phone_number')
                  } }
                />
              </InputCol>
            </FormGroup>
            <TextSection>System Info.</TextSection>
            {/* <FormGroup>
              <LabelCol>
                <Label>Status User ID</Label>
              </LabelCol>
              <InputCol>
                <SearchSelect
                  name='is_active'
                  placeholder='Select Status User ID'
                  value={ status }
                  options={ _status }
                  onChange={ e => handleInput(e, 'is_active') }
                />
              </InputCol>
            </FormGroup> */}
            <FormGroup>
              <LabelCol>
                <Label>Modified Date</Label>
              </LabelCol>
              <InputCol>Not yet modified</InputCol>
            </FormGroup>
            <FormGroup>
              <LabelCol>
                <Label>Modified By</Label>
              </LabelCol>
              <InputCol>Not yet modified</InputCol>
            </FormGroup>
          </FormWrapper>
        </Form>
      </Container>
    </Root>
  )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
`

const Container = styled.div`
    padding: 16px 24px;
    background: #FFFFFF;
    max-height: calc(100vh - 240px);
    overflow-y: scroll;
`

const Label = styled.span`
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;

    ${p => p.required && `
      ::after {
        content: '*';
        color: red;
      }
    `}
`

const Form = styled.div`
    display: flex;
`

const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    :nth-child(1) {
        padding-right: 6px;
    }

    :nth-last-child(1) {
        padding-left: 6px;
    }
`

const FormGroup = styled.div`
    display: flex;
    margin-bottom: 16px;
`

const LabelCol = styled.div`
    display: flex;
    flex: 1;
`

const InputCol = styled.div`
    display: flex;
    flex: 2;

    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    color: #808080;
`

const TextSection = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
  margin-bottom: 24px;
`



// WEBPACK FOOTER //
// ./src/components/new-employee/create-form/personal-info.js